<template>
  <div>
    <label>
      <input
        type="checkbox"
        name="compare-product-list-item"
        :checked="isInCompareList(product.id)"
        @click="toggleCompareProductList(product.id)"
      >
      {{ $t('Compare') }}
    </label>
  </div>
</template>

<script setup lang="ts">
export interface Props {
  product: {
    id: string
  }
}
defineProps<Props>()

const { isInCompareList, toggleCompareProductList } = useCompareProductList()
</script>
